import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const SystemsReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions("EffectiveDate"),
    ...FormActionReducer.defaultRecordState()
  },
  action) => {

  if (action.scope === ScopeConstants.SYSTEM) {
    return FormActionReducer.reduce(action, state)
  }

  return state
}